import { render, staticRenderFns } from "./PatientReportForm.vue?vue&type=template&id=7123cc87&scoped=true&"
import script from "./PatientReportForm.vue?vue&type=script&lang=js&"
export * from "./PatientReportForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientReportForm.vue?vue&type=style&index=0&id=7123cc87&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123cc87",
  null
  
)

export default component.exports